import {
  IconButton,
  TableRowActions,
  Tooltip,
} from "@songtradr-one/components-frontend";
import { Props } from "./IconColumn.Parts";

export const IconColumn = ({
  children,
  action,
  tip,
  disabled = false,
  className,
}: Props) => (
  <TableRowActions className={className}>
    <Tooltip tip={tip}>
      <IconButton
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          if (action) action();
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  </TableRowActions>
);
